module.exports = __webpack_public_path__ + "img/jacobsen_Jord_og_jern1.33799683.jpg";